/* eslint-disable sort-keys */
import { createMuiTheme } from '@material-ui/core/styles';
import { MuiPickersOverrides } from '@material-ui/pickers/typings/overrides';

type overridesNameToClassKey = {
  [P in keyof MuiPickersOverrides]: keyof MuiPickersOverrides[P];
};

declare module '@material-ui/core/styles/overrides' {
  // @ts-ignore
  export type ComponentNameToClassKey = overridesNameToClassKey;
}

export const commonTheme = createMuiTheme({
  overrides: {
    MuiFab: {
      sizeSmall: {
        height: 24,
        minHeight: 24,
        width: 24,
      },
    },
    MuiFormControl: {
      root: {
        width: 'inherit',
      },
    },
    MuiFormHelperText: {
      contained: {
        margin: '.25rem .75rem 0',
      },
      root: {
        '&.Mui-error': {
          color: '#bd2e2a',
        },
      },
    },
    MuiFormLabel: {
      asterisk: {
        color: '#bd2e2a',
      },
      root: {
        color: '#62695e',
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: 1.5,
        lineHeight: 1.67,
        textTransform: 'uppercase',
      },
    },
    MuiIconButton: {
      root: {
        color: 'inherit',
      },
    },
    MuiInputAdornment: {
      positionEnd: {
        color: '#373737',
      },
      root: {
        color: '#82bc00',
      },
    },
    MuiInputBase: {
      formControl: {
        'label + &': {
          marginTop: 20,
        },
      },
    },
    MuiInputLabel: {
      shrink: {
        transform: 'unset',
      },
    },
    MuiMenuItem: {
      root: {
        borderBottom: '0.03125rem solid #dedede',
        color: '#373737',
        fontFamily: ['"Open Sans"', '"Helvetica Neue"', 'Arial', 'sans-serif'].join(','),
        padding: '0.625rem 1rem',
        whiteSpace: 'normal',
        '&:last-child': {
          borderBottom: 0,
        },
        '&.Mui-disabled': {
          display: 'none',
        },
        '&$selected': {
          background: '#fff !important',
        },
      },
    },
    MuiOutlinedInput: {
      adornedStart: {
        paddingLeft: 0,
      },
      input: {
        backgroundColor: 'transparent',
        color: '#373737',
        '.Mui-error &': {
          color: '#bd2e2a',
        },
        '.Mui-error.Mui-focused &': {
          color: '#373737',
        },
        padding: '0.5rem 0.25rem',
      },
      notchedOutline: {
        border: 0,
        '&:hover': {
          border: '2px solid #007bbd',
        },
      },
      root: {
        backgroundColor: '#fff',
        border: '1px solid #dedede',
        borderRadius: 12,
        boxShadow: 'inset 0 1px 3px 0 #00000014',

        color: '#373737',
        fontFamily: ['"Open Sans"', '"Helvetica Neue"', 'Arial', 'sans-serif'].join(','),
        padding: '0.5625rem',
        '&:hover': {
          boxShadow: '0 0 0 2px #007bbd',
        },
        '&.MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
          padding: '0.5625rem',
          paddingRight: '0.875rem !important',
        },
        '&.Mui-disabled': {
          background: '#ccc',
        },
        '&.Mui-focused': {
          boxShadow: '0 0 0 2px #007bbd',
          '[aria-expanded="true"] &': {
            '& > .MuiInputAdornment-positionEnd': {
              color: '#007bbd',
              transform: 'rotate(180deg)',
            },
          },
        },
        '&.Mui-error': {
          boxShadow: '0 0 0 2px #bd2e2a',
          color: '#bd2e2a',
        },
      },
    },
    // @ts-ignore
    MuiPagination: {
      root: {
        display: 'flex',
        justifyContent: 'center',
        '& .MuiPaginationItem-page': {
          color: '#373737',
          fontSize: 12,
          '&.Mui-selected': {
            background: '#fff',
            color: '#663573',
          },
        },
      },
    },
    // @ts-ignore
    MuiPickersDay: {
      current: {
        color: '#007bbd',
      },
      daySelected: {
        backgroundColor: '#007bbd',
        '&:hover': {
          backgroundColor: '#0a6799',
        },
      },
    },
    MuiSelect: {
      select: {
        '&:focus': {
          backgroundColor: 'transparent',
        },
      },
    },
  },
  props: {
    MuiIconButton: {
      'aria-label': 'button',
    },
    MuiInputBase: {
      inputProps: { 'aria-label': 'input' },
    },
  },

  typography: {
    fontFamily: ['"Open Sans"', '"Helvetica Neue"', 'Arial', 'sans-serif'].join(','),
    button: {
      textTransform: 'none',
    },
  },
});
